<template>
  <div>
    <el-upload
      v-loading.body="uploading"
      ref="upload"
      :on-preview="handlePictureCardPreview"
      :on-change="onFileChange"
      :before-remove="beforeRemove"
      :on-remove="handleRemove"
      :auto-upload="false"
      :file-list="imageList"
      :limit="limit"
      :on-exceed="handleExceed"
      :http-request="uploadFile"
      element-loading-text="上传中..."
      action=""
      class="upload-demo"
      list-type="picture-card"
      :disabled="customUploadDisable"
      multiple>
      <span :class="{ hid: ishid }"></span>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img :src="dialogImageUrl" width="100%" alt="">
    </el-dialog>
<!--    <el-button :disabled="uploadDisable" style="margin:20px 0;" size="small" type="success" @click="submitUpload">-->
<!--      点击确认图片上传到服务器-->
<!--    </el-button>-->
  </div>
</template>

<script>
export default {
  name: 'CustomUpload',
  props: {
    id: {
      type: [String, Number],
      default: undefined
    },
    imageList: {
      type: Array,
      default: undefined
    },
    limit: {
      type: Number,
      required: true
    },
    uploadApi: {
      type: String,
      default: ''
    },
    deleteImageUrl: {
      type: String,
      default: ''
    },
    customUploadDisable: {
      type: Boolean,
      default: false
    },
    ishid: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      uploading: false,
      dialogVisible: false,
      dialogImageUrl: '',
      newChooseImage: [],
      uploadDisable: true,
      haveFile: false
    }
  },
  methods: {
    beforeRemove (file, fileList) {
      return this.$confirm('您确定要删除该图片？')
    },
    handleExceed () {
      this.$message.warning(`当前板块最多允许上传${this.limit}个文件`)
    },
    onFileChange (file, fileList) {
      if (file.status === 'ready') { // 选择文件之后
        this.uploadDisable = false
        this.newChooseImage.push(file.name)
        this.$emit('uploaded', false)
      }
      // this.submitUpload()
    },
    submitUpload () {
      this.formData = new FormData()
      this.$refs.upload.submit()
      if (!this.haveFile) {
        this.$emit('noFile')
        return false
      }
      this.uploading = true
      this.formData.append('folder', 'message')
      let uploadApi = window.SITE_CONFIG.baseUploadUrl + this.uploadApi
      this.$http({
        url: uploadApi,
        method: 'post',
        data: this.formData
      }).then((res) => {
        this.uploading = false
        if (res.data.data.length > 0) {
          res.data.data.forEach(item => {
            this.imageList.push({name: item.http, url: item.http})
          })
        }
        this.uploadDisable = true
        this.$emit('uploaded', true)
        this.$emit('imagePath', res.data.data)
        this.newChooseImage = []
        this.$emit('uploadSuccess', res.data.data)
      }).catch((res) => {
        this.$message.error('图片上传失败，请检查。')
        this.uploading = false
      })
    },
    uploadFile (file) {
      this.haveFile = true
      this.formData.append('file', file.file)
    },
    handleRemove (file, fileList) {
      if (this.newChooseImage.indexOf(file.name) > -1) {
        this.newChooseImage.splice(this.newChooseImage.indexOf(file.name), 1)
        if (this.newChooseImage.length < 1) {
          this.uploadDisable = true
          this.$emit('uploaded', true)
        }
        return false
      }
      this.$http({
        url: window.SITE_CONFIG.fileBaseUrl + this.deleteImageUrl,
        method: 'delete',
        params: {
          'images': file.name,
          'id': this.id
        }
      }).then(() => {
        const index = this.imageList.findIndex(image => {
          return image.name === file.name
        })
        this.imageList.splice(index, 1)
        if (this.imageList.length < 1) {
          this.$emit('isEmpty', true)
        }
        this.$message.success('删除成功')
      })
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.hid{
  display: none!important;
}
</style>



// WEBPACK FOOTER //
// src/components/upload/CustomUpload.vue